export default __webpack_public_path__ + "static/media/oval.34efa7ed.svg";